import { create } from "zustand";

function generateId(): string {
	if (typeof crypto !== "undefined" && crypto.randomUUID) {
		return crypto.randomUUID();
	}
	return Math.random().toString(36).substring(2) + Date.now().toString(36);
}

export type ToastType = "success" | "info" | "warning" | "error";

export interface Toast {
	id: string;
	type: ToastType;
	message: string;
	title?: string;
	image?: string;
	link?: string;
	duration: number;
	dismissible: boolean;
}

interface ToastState {
	toasts: Toast[];
}

interface ToastActions {
	addToast: (
		toast: Omit<Toast, "id" | "duration" | "dismissible"> &
			Partial<Pick<Toast, "duration" | "dismissible">>,
	) => string;
	removeToast: (id: string) => void;
	clearAll: () => void;
}

export const useToastStore = create<ToastState & ToastActions>()((set) => ({
	toasts: [],

	addToast: (toast) => {
		const id = generateId();
		const newToast: Toast = {
			...toast,
			id,
			duration: toast.duration ?? 5000,
			dismissible: toast.dismissible ?? true,
		};
		set((state) => ({ toasts: [...state.toasts, newToast] }));
		return id;
	},

	removeToast: (id) => {
		set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
	},

	clearAll: () => set({ toasts: [] }),
}));
